export default __webpack_public_path__ + "static/media/Tech Visa.1c4cfb1d.jpg";